import util from "../../lib/util";
import React, {FC} from "react";
import {normalizePaymentMeta} from "./normalizePaymentMeta";

const FormatProcessorPaymentMeta: FC<any> = raw => {
    const ppm = normalizePaymentMeta(raw);
    if (!ppm) return null;

    return <div style={{
        display: 'grid',
        gridTemplateColumns: 'max-content 1fr',
        gap: '10px'
    }}>
        {ppm.id && <>
			<label>ID</label>
			<span>{ppm.id}</span>
		</>}

        {ppm.created && <>
			<label>Created</label>
			<span>{new Date(ppm.created).toLocaleString()}</span>
		</>}

        {ppm.modified && <>
			<label>Modified</label>
			<span>{new Date(ppm.modified).toLocaleString()}</span>
		</>}

        {ppm.statusText && <>
			<label>Status</label>
			<span>{ppm.statusText}</span>
		</>}

        {ppm.typeText && <>
			<label>Type</label>
			<span>{ppm.typeText}</span>
		</>}

        {ppm.authorization && <>
			<label>Authorization Code</label>
			<span>{ppm.authorization}</span>
		</>}

        {ppm.amount != null && <>
			<label>Amount</label>
			<span>${util.numberWithCommas(ppm.amount)}</span>
		</>}

        {ppm.amount_refunded > 0 && <>
			<label>Amount Refunded</label>
			<span>${util.numberWithCommas(ppm.amount_refunded)}</span>
		</>}
    </div>
}

export default FormatProcessorPaymentMeta;
